'use client'

import { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { useTheme } from 'next-themes'
import { usePrefersReducedMotion } from '@/hooks/usePrefersReducedMotion'

const GoldenFireflies = dynamic(
  () => import('./HeroParticles').then((m) => m.GoldenFireflies),
  { ssr: false }
)
const GoldenSparkles = dynamic(
  () => import('./HeroParticles').then((m) => m.GoldenSparkles),
  { ssr: false }
)

export default function HeroParticlesLayer() {
  const prefersReducedMotion = usePrefersReducedMotion()
  const { resolvedTheme } = useTheme()
  const [shouldRenderParticles, setShouldRenderParticles] = useState(false)

  useEffect(() => {
    if (prefersReducedMotion) return

    // The particle canvases are decorative only, so defer them until the main
    // hero text and showcase image have already had a chance to load first.
    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(() => {
        setShouldRenderParticles(true)
      })

      return () => window.cancelIdleCallback(idleId)
    }

    const timeoutId = setTimeout(() => {
      setShouldRenderParticles(true)
    }, 0)

    return () => clearTimeout(timeoutId)
  }, [prefersReducedMotion])

  if (prefersReducedMotion || !shouldRenderParticles || !resolvedTheme)
    return null

  return (
    <>
      {resolvedTheme === 'dark' ? (
        <GoldenFireflies density={35} />
      ) : (
        <GoldenSparkles density={70} />
      )}
    </>
  )
}
